import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import deDE from 'antd/locale/de_DE';
import App from './App';
import 'antd/dist/reset.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfigProvider locale={deDE}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
